Pluswerk.PlusProject.CountDown = Pluswerk.PlusProject.CountDown || {};
/**
 * CountDownControllerController
 *
 * @author Tarcea Madalina <madalina.tarcea@pluswerk.ag>
 */
Pluswerk.PlusProject.CountDown.CountDownController = function () {
  // Set the date we're counting down to
  if($('#heroImageDate').length) {
    var s = $('#heroImageDate').data("date").replace(/ /g, "T");
    var formatDate = $('#heroImageDate').data("dateformat");

    var a = s.split(/[^0-9]/);
    var endDate = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
  }
  if (endDate) {
    calculacteCountdown();

    // Update the count down every 1 second
    var x = setInterval(function () {
      calculacteCountdown();
    }, 1000);
  }

  function calculacteCountdown() {
    var countDownDate = new Date(endDate).getTime();
    // Get todays date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var digits = ("" + days).split("");
    var d = "";
    for (index = 0; index < digits.length; ++index) {
      d = d + '<span id="timeleft">' + digits[index] + '</span>';
    }
    var hour = ("" + hours).split("");
    var h = "";
    for (index = 0; index < hour.length; ++index) {
      h = h + '<span id="timeleft">' + hour[index] + '</span>';
    }
    var min = ("" + minutes).split("");
    var m = "";
    for (index = 0; index < min.length; ++index) {
      m = m + '<span id="timeleft">' + min[index] + '</span>';
    }
    var sec = ("" + seconds).split("");
    var s = "";
    for (index = 0; index < sec.length; ++index) {
      s = s + '<span id="timeleft">' + sec[index] + '</span>';
    }
    if(distance > 0) {
      $(".js-countdownDays").html(d);
      $(".js-countdownHours").html(h);
      $(".js-countdownMinutes").html(m);
      if (formatDate == '0') {
        $(".js-countdownSeconds").html(s);
      }
    }
    if ($(".teaserBox__countDown").is(':hidden')) {
      $(".teaserBox__countDown").css('display', 'block');
    }
    if ($(".teaserBox__textBeforeCountDown").is(':hidden')) {
      $(".teaserBox__textBeforeCountDown").css('display', 'block');
    }
    if ($(".teaserBox__textBelowCountDown").is(':hidden')) {
      $(".teaserBox__textBelowCountDown").css('display', 'block');
    }

    // If the count down is over, write 00 00:00:00
    if (distance <= 0) {
      clearInterval(x);
      $(".js-countdownDays").html('0');
      $(".js-countdownHours").html('0');
      $(".js-countdownMinutes").html('0');
      if (formatDate == '0') {
        $(".js-countdownSeconds").html('0');
      }
    }
  }
  var days = $(".js-countdownDays");
  var hours = $(".js-countdownHours");
  var minutes = $(".js-countdownMinutes");
  var days_text = days.children("span").text();
  var hours_text = hours.children("span").text();
  var minutes_text = minutes.children("span").text();
  if (formatDate == '0') {
    var seconds = $(".js-countdownSeconds");
    var seconds_text = seconds.children("span").text();
  }
  if((minutes_text <= 0) && (hours_text <= 0) && (days_text <= 0)) {
    if (formatDate == '0') {
      if (seconds_text <= 0) {
        $(".teaserBox__textBeforeCountDown").remove();
        $("#heroImageDate").remove();
        $(".teaserBox__textBelowCountDown").remove();
      }
    } else {
      $(".teaserBox__textBeforeCountDown").remove();
      $("#heroImageDate").remove();
      $(".teaserBox__textBelowCountDown").remove();
    }
  }
};
